import { useEffect } from "react";
import { ArrowLeft, ExternalLink, Smartphone } from "lucide-react";

const PROTOTYPE_URL = "https://app.unboxing-bella.live/";

export default function AppPreview() {
  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    const previousRobots = robots?.getAttribute("content");
    const previousTitle = document.title;

    if (robots) robots.setAttribute("content", "noindex, nofollow, noarchive");
    document.title = "APP · Anto&Bella por el Mundo";

    return () => {
      if (robots && previousRobots) robots.setAttribute("content", previousRobots);
      document.title = previousTitle;
    };
  }, []);

  return (
    <main
      className="min-h-screen overflow-hidden bg-mist px-5 py-6 sm:px-8 lg:px-12"
      data-testid="app-preview-page"
    >
      <div className="mx-auto flex min-h-[calc(100vh-3rem)] max-w-6xl flex-col justify-between">
        <header className="flex items-center justify-between gap-4">
          <a
            href="/"
            data-testid="app-preview-home-link"
            className="inline-flex items-center gap-2 font-display text-sm font-bold text-ink transition-colors hover:text-coral"
          >
            <ArrowLeft className="h-4 w-4" /> Anto<span className="text-coral">&</span>Bella
          </a>
          <span
            data-testid="app-preview-status"
            className="rounded-full border border-ink/10 bg-white px-3 py-1.5 font-mono text-[10px] uppercase tracking-widest text-ink/55"
          >
            Vista previa
          </span>
        </header>

        <section className="grid items-center gap-12 py-16 lg:grid-cols-[1fr_minmax(300px,440px)] lg:gap-20">
          <div className="max-w-xl">
            <span className="font-mono text-xs uppercase tracking-widest text-coral">La app · Anto & Bella</span>
            <h1
              data-testid="app-preview-heading"
              className="mt-5 font-display text-4xl font-extrabold leading-[0.96] text-ink sm:text-5xl lg:text-6xl"
            >
              El mundo sigue después de la pantalla.
            </h1>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink/70">
              Explora el prototipo de la segunda pantalla de Anto&Bella: Anto & Bella por el Mundo™ es un show transmedia de viajes y competencias culturales — TV abierta, app y 20 plataformas digitales — con dos amigas que transforman cada destino en un aula sin paredes. El Piloto 1 es tu primera oportunidad de aparecer dentro del contenido, no alrededor de él.
            </p>
            <a
              href={PROTOTYPE_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="app-preview-open-prototype-link"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 font-semibold text-white transition-[background-color,transform] hover:-translate-y-0.5 hover:bg-coral"
            >
              Abrir prototipo <ExternalLink className="h-4 w-4" />
            </a>
          </div>

          <div className="relative mx-auto w-full max-w-sm">
            <div className="absolute inset-x-8 bottom-0 h-4 rounded-full bg-sky/35 blur-xl" aria-hidden="true" />
            <div className="relative aspect-[10/13] overflow-hidden rounded-[2rem] border-[10px] border-ink bg-white shadow-2xl">
              <img
                src="/assets/duo_app.png"
                alt="Anto y Bella en la app"
                data-testid="app-preview-image"
                className="h-full w-full object-cover object-center"
              />
              <div className="absolute bottom-0 left-0 right-0 flex items-center gap-3 bg-ink/90 px-5 py-4 text-white">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-coral"><Smartphone className="h-4 w-4" /></span>
                <span className="font-display text-sm font-bold">Anto&Bella · App</span>
              </div>
            </div>
          </div>
        </section>

        <p className="pb-2 text-center font-mono text-[10px] uppercase tracking-widest text-ink/45" data-testid="app-preview-indexing-note">
          CONFIDENCIAL · Anto & Bella™ por el Mundo — Dos amigas. El mundo entero, una maleta. · Propiedad exclusiva de Emilio Edison Gallegos, CEO & FOUNDER del Grupo HiperconverCloud. · Cifras estimadas con fines ilustrativos. El desempeño real varía por destino, acto contratado y temporada.
        </p>
      </div>
    </main>
  );
}